import { RichTreeView, RichTreeViewProps, treeItemClasses } from '@mui/x-tree-view';
import { useEffect } from 'react';
import { APICallFunction, APIParams } from '../../pages/userMangement/role/apiCall';
import { useAppSelector } from '../../store/hooks';
import { cleanUpReducers } from '../../common/commonFunctions';
import { Box, Typography } from '@mui/material';

interface IMuiTreeView extends RichTreeViewProps<{}, boolean> {
  getTreeData: APICallFunction
  apiKey: string
  apiRequest: APIParams['request']
  label: string
}

const defaultApiKey = '_TreeView'
const defaultGetTreeData: IMuiTreeView['getTreeData'] = (params) => undefined

export default function MuiRichTreeView(props: Partial<IMuiTreeView>) {
  const crud = useAppSelector(state => state.crud)
  const { label = 'TreeView', getTreeData = defaultGetTreeData, apiKey = defaultApiKey, items = crud[apiKey]?.data, apiRequest = {}, sx, ...others } = props;

  useEffect(() => {
    if (getTreeData) getTreeData({ request: apiRequest });

    return () => {
      cleanUpReducers([apiKey])
    }
  }, [])


  return (items?.length ?
    <Box
      border='1px solid rgb(240,240,240)'
      borderRadius={2}
      mt={2}
      position='relative'
    >
      <Typography
        position='absolute'
        left={16}
        fontSize={12}
        bgcolor='white'
        px={1}
        color='rgb(150,150,150)'
        zIndex={10}
        lineHeight={1}
        sx={{ transform: 'translateY(-50%)' }}
      >{label}</Typography>
      <RichTreeView
        items={items}
        itemChildrenIndentation={0}
        aria-label='tree-view'
        sx={{
          p: 1,
          maxHeight: '200px',
          overflowY: 'auto',
          [`& .${treeItemClasses.groupTransition}`]: {
            borderLeft: "1px solid rgb(220,220,220)",
            marginLeft: 2,
            bgcolor: 'rgba(0,0,0,0.02)'
          },
          ...sx
        }}
        {...others}
      />
    </Box>
    : null
  )
}
